// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"Popover_closeButton__q4P1h"};